module.exports = __webpack_public_path__ + "img/by.26a195d.svg";